export default "__VITE_ASSET__QVzm_K05__"